import React, { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { FiAlertTriangle } from 'react-icons/fi';
import { useModalKeyTrap } from '../../hooks/useModalKeyTrap';
import './ExpiryWarningModal.css';

interface ExpiryWarningModalProps {
  daysLeft: number;
  onClose: () => void;
}

const ExpiryWarningModal: React.FC<ExpiryWarningModalProps> = ({ daysLeft, onClose }) => {
  const { t } = useTranslation();
  const btnRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    btnRef.current?.focus();
  }, []);

  useModalKeyTrap(useCallback(function (key, e) {
    if (key === 'Enter' || key === 'Space' || key === 'Back') {
      e.preventDefault();
      onClose();
    }
  }, [onClose]));

  const message =
    daysLeft <= 0
      ? t('expiryWarning.messageToday')
      : t('expiryWarning.message', { count: daysLeft });

  return (
    <div className="expiry__overlay">
      <div className="expiry__box">
        <div className="expiry__icon"><FiAlertTriangle size={40} /></div>
        <p className="expiry__title">{t('expiryWarning.title')}</p>
        <p className="expiry__message">{message}</p>
        <button
          ref={btnRef}
          className="expiry__btn"
          onClick={onClose}
        >
          {t('common.ok')}
        </button>
      </div>
    </div>
  );
};

export default ExpiryWarningModal;
